<template>
    <div class="modal-overlay">
        <div class="modal">
            <h3>CPF:</h3>
            <form @submit.prevent="submitCpf">
                <div>
                    <input
                        class="input-center"
                        type="text"
                        id="cpfCnpjInput"
                        v-model="cpf"
                        v-cpf
                        maxlength="14"
                        @input="errorMessage = ''"
                    />
                </div>

                <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
                
                <div class="actions">
                    <button class="btn-confirm" type="submit">Confirmar</button>
                    <button v-if="props.allowSemCpf" class="btn-secondary" type="button" @click="submitSemCpf">Não Informar</button>
                    <button class="btn-cancel" type="button" @click="closeModal">Cancelar</button>
                </div>
            </form>
        </div>
    </div>
</template>
  

<script setup>
import { ref } from 'vue'
import { Funcoes } from '@/funcoes/utils';

const props = defineProps({
    allowSemCpf: {type: Boolean, default: false}
})

const emit = defineEmits([
    'cpfSubmitted',
    'close'
])

const cpf = ref('')
const errorMessage = ref('')


function submitCpf() {
    try {
        Funcoes.validarCPF(cpf.value)
        emit('cpfSubmitted', cpf.value)
    } catch (error) {
        errorMessage.value = error.message
    }
}


function submitSemCpf() {
    emit('cpfSubmitted', '')
}


function closeModal() {
    emit('close')
}
</script>

  
<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
  
.modal {
    background: #fff;
    padding: 20px;
    border-radius: 5px;
    width: 300px;
}
  
.actions {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
    gap: 10px;
}

.error-message {
    color: red;
    font-weight: bold;
    margin-top: 10px;
}
</style>
  